/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getRateCardDetails } from "api/services/rateCard";
import { rateCardQueryKeys } from "./rateCardQueryKeys";

export const useGetRateCardDetails = (rateCardId: string, options?: UseQueryOptions) =>
  useQuery<any>({
    queryKey: rateCardQueryKeys.rateCardDetails(rateCardId),
    queryFn: ({ signal }) => getRateCardDetails(rateCardId, { signal }).then((res) => res.data),
    ...options,
  });
